export const isEmpty = (value: string | null | undefined | number): boolean => {
    return (value === null || value === undefined || value === "");
};
